<template>
  <div>
    <div class="container">
      <div class="banner" title="免费领取次数" ref="banner" @click="$router.push('/apiMargetDetail/1')"></div>

      <div class="ts-main-tit">产品优势</div>

      <div class="ts-main-desc">多年图书数据沉淀，只专注于图书，服务有保障，使用更放心</div>
      <div class="block">
        <div class="ts-block">
          <div class="advantage-item-tit">高效</div>
          <div class="advantage-item-des">
            接口快速响应，满足大部分企业及个人开发者的需求。
          </div>
          <div class="advantage-item-con">
            接口简单标准，减少开发成本。
          </div>
          <div class="advantage-item-con">快速申请、调试，对接更高效。</div>
          <div class="advantage-item-con">7x24小时全天候服务响应。</div>
        </div>
        <div class="ts-block">
          <div class="advantage-item-tit">安全</div>
          <div class="advantage-item-des">
            高风控高防护，为您提供全方位的技术保护。
          </div>
          <div class="advantage-item-con">
            采用先进的数据加密存储技术和容灾备份方案，有效保护您的个人信息。
          </div>
          <div class="advantage-item-con">
            通过HTTPS加密通道和数据脱敏处理，保障信息传输的安全性。
          </div>
          <div class="advantage-item-con">
            遵循高级别的风控标准，实施内部多重管控策略，确保数据的合规性和安全性。
          </div>
        </div>
        <div class="ts-block">
          <div class="advantage-item-tit">稳定</div>
          <div class="advantage-item-des">
            集群式系统部署，为数据服务提供了坚实的保障。
          </div>
          <div class="advantage-item-con">
            服务器并行响应，能够提供稳定且高效的数据服务。
          </div>
          <div class="advantage-item-con">
            连续多年持续保障了平台数据安全和稳定。
          </div>
          <div class="advantage-item-con">成功率≥99%，稳定性≥99%。</div>
        </div>
      </div>
    </div>

    <div class="ts-footer-bg">
      一站式数据平台 构建数据生态
      <a v-if="!userInfo.token" class="nowReg" @click="$router.push('/reg')"
        >立即注册</a
      >
    </div>

    <div class="ts-fixed" ref="ts-fixed">
      <div class="ts-weixin1">
        联系客服1
        <div class="ts-weixin-bg1"></div>
      </div>
      <div class="ts-weixin2">
        联系客服2
        <div class="ts-weixin-bg2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'HomeIndex',
  data () {
    return {
    }
  },
  methods: {},
  computed: {
    ...mapState(['userInfo', 'globalCheckLoginTimerId']),
    ...mapGetters(['token'])
  },
  mounted () {
    // 页面向下滚动100px显示联系客服样式
    // 使用箭头函数保持正确的 this 上下文
    window.addEventListener('scroll', () => {
      const banner = this.$refs.banner
      if (banner) {
        const bannerTop = banner.offsetTop
        const scrollTop = document.documentElement.scrollTop

        if (scrollTop >= bannerTop) {
          this.$refs['ts-fixed'].style.opacity = 1
        } else {
          this.$refs['ts-fixed'].style.opacity = 0
        }
      }
    })
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
.nowReg {
  cursor: pointer;
}
.banner {
  margin: 30px 0;
  border-radius: 12px;
  height: 420px;
  background: url("/public/banner4.jpg") center/cover;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(0,0,0,0.12);
  }
}
.ts-main-tit {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin: 50px 0 20px;
  text-align: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 3px;
    background: #409EFF;
    border-radius: 2px;
  }
}
.ts-main-desc {
  font-size: 15px;
  color: #909399;
  margin-bottom: 40px;
  text-align: center;
}

.block {
  display: flex;
  justify-content: space-between;
}

.ts-block {
  padding: 30px;
  background: #fff;
  width: 360px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 16px rgba(0,0,0,0.1);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background: linear-gradient(180deg, #409EFF, #67C23A);
  }
}

.advantage-item-tit {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-left: 30px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    background-size: contain;
  }
}

// 高效图标
.ts-block:nth-child(1) .advantage-item-tit::before {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="%23409EFF" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg>');
}

// 安全图标
.ts-block:nth-child(2) .advantage-item-tit::before {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="%2367C23A" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.45 3.61-2.86 6.62-7 7.97V12H5V6.3l7-3.11v8.8z"/></svg>');
}

// 稳定图标
.ts-block:nth-child(3) .advantage-item-tit::before {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="%23E6A23C" d="M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>');
}

.advantage-item-des {
  color: #606266;
  font-size: 15px;
  line-height: 1.6;
  padding: 0 0 15px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.advantage-item-con {
  color: #909399;
  font-size: 14px;
  line-height: 1.8;
  padding: 12px 0;
  position: relative;
  padding-left: 28px;

  &::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #67C23A;
    font-weight: bold;
    width: 20px;
    text-align: center;
  }
}

.ts-footer-bg {
  margin-top: 80px;
  height: 180px;
  background: linear-gradient(135deg, #409EFF, #67C23A);
  color: #fff;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  text-align: center;

  a {
    width: 140px;
    height: 36px;
    line-height: 36px;
    border-radius: 18px;
    font-size: 15px;
    color: #fff;
    margin-top: 20px;
    transition: all .3s;
    border: 1px solid rgb(255, 255, 255);

    &:hover {
      background: rgba(255,255,255,0.1);
      transform: translateY(-2px);
    }
  }
}

.ts-fixed {
  width: 65px;
  height: 180px;
  background: linear-gradient(135deg, #409EFF, #67C23A);
  position: fixed;
  right: 30px;
  bottom: 190px;
  border-radius: 30px;
  padding: 0 6px;
  padding-top: 20px;
  box-sizing: border-box;
  opacity: 0;
  transition: all 1s;
}

.ts-fixed .ts-weixin1 {
  width: 55px;
  height: 70px;
  font-size: 12px;
  cursor: pointer;
  color: #fff;
  border-bottom: 2px solid #fff;
  line-height: 70px;
  position: relative;
}

.ts-fixed .ts-weixin2 {
  width: 55px;
  height: 70px;
  font-size: 12px;
  cursor: pointer;
  color: #fff;
  line-height: 70px;
}

.ts-weixin-bg1 {
  width: 300px;
  height: 300px;
  position: absolute;
  right: 61px;
  top: -3px;
  background: url("/public/wenxin.jpg");
  background-size: 100% 100%;
  display: none;
}

.ts-weixin-bg2 {
  width: 300px;
  height: 300px;
  position: absolute;
  right: 65px;
  top: 17px;
  background: url("/public/weixin2.jpg");
  background-size: 100% 100%;
  display: none;
}

.ts-fixed .ts-weixin1:hover .ts-weixin-bg1 {
  display: block;
}

.ts-fixed .ts-weixin2:hover .ts-weixin-bg2 {
  display: block;
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .banner {
    height: 200px;
    margin: 15px 0;
    border-radius: 8px;
  }

  .ts-main-tit {
    font-size: 20px;
    margin: 30px 0 15px;
  }

  .ts-main-desc {
    font-size: 13px;
    margin-bottom: 25px;
  }

  .block {
    flex-direction: column;
    padding: 0 12px;
  }

  .ts-block {
    width: 100%;
    padding: 20px;
    margin-bottom: 15px;
    border-radius: 12px;

    &::before {
      width: 4px;
    }
  }

  .advantage-item-tit {
    font-size: 18px;
  }

  .advantage-item-des {
    font-size: 14px;
  }

  .advantage-item-con {
    font-size: 13px;
  }

  .ts-footer-bg {
    height: 120px;
    font-size: 16px;
    margin-top: 40px;

    a {
      width: 100px;
      height: 30px;
      line-height: 30px;
      font-size: 13px;
      margin-top: 15px;
    }
  }

  .ts-fixed {
    display: none;
  }
}
</style>
